module.exports = __webpack_public_path__ + "img/sh.2e9c71c7.svg";